import { useEffect, useMemo } from "react";
import { useBrowserStoredValue } from "../../../toolympus/hooks/useBrowserStoredValue";
import { useLoadedData } from "../../../toolympus/hooks/useLoadedData";
import { createSelectSchema, useSingleSchema } from "../../../toolympus/hooks/useSchema";
import { useSmartList } from "../../../toolympus/hooks/useSmartList";
import { useEditItem2 } from "../../../toolympus/api/useNewItem";
import { apiFetch } from "../../../toolympus/api/core";

export interface CalendarEvent {
  _id: number;
  year?: string | null;
  title: string;
  title_ru?: string;
  cover_image?: string;
  created_at?: string;
  organiser_companies?: any[] | null;
  organiser_companies_ru?: any[] | null;
  registration_status?: string;
  registration_external_url?: string;
  event_format?: string;

  is_published?: boolean;
  published_at?: string;
  published_by?: string;

  description_short?: any;
  description_short_ru?: any;
  description?: any;
  description_ru?: any;

  price_option?: string;

  start_datetime?: string;
}


export const AdminEventApiPath = "/api/calendar/admin";
export const CoorgEventApiPath = "/api/calendar/coorg";

export const useCalendarEventSchema = () => {
  const { schema } = useSingleSchema(`${AdminEventApiPath}/uiconfig`);
  return schema;
}

export const useCalendarEventCoorgSchema = () => {
  const { schema } = useSingleSchema(`${CoorgEventApiPath}/uiconfig`);
  return schema;
}

const EventTextFilter = (r: CalendarEvent) => `${r.title} ${r.title_ru} ${r._id}`;

export const useEventsAdminList = () => {
  const schema = useCalendarEventSchema();

  // const assignedFilter = useBrowserStoredValue("me", undefined, "__mp_documents_my_all");

  const data = useSmartList(AdminEventApiPath, {
    sorting: {
      disallowedFields: ["description"],
    },
    extraParams: {
      // assigned: assignedFilter.value === "me" ? "me" : undefined,
    },
    viewDefault: "all",
    lsKeysPrefix: "__riac_events_adm",
    newRecordDefault: { title: "" },
    schema,
    textFilterFn: EventTextFilter,
  });

  const archiveEvents = useEditItem2<{ year: string }>({
    save: async (item) => {
      await apiFetch(`/api/calendar/archive`, "post", item);
      data.reload();
      return item;
    }
  });

  return {
    ...data,
    archiveEvents,
    // assignedFilter,
  }
  
}

export const useEventsArchiveList = () => {
  const schema = useCalendarEventSchema();

  const yearOptionsData = useLoadedData<{ year: string }[]>("/api/calendar/archive-years", []);
  const yearSelectorSchema = useMemo(() => {
    return createSelectSchema(
      yearOptionsData.data.filter(y => !!y.year).map(y => ({ value: y.year, label: y.year })), {
        label: "Year",
      })
  }, [yearOptionsData.data]);

  const year = useBrowserStoredValue("", "year", "__riac_archive_year");

  useEffect(() => {
    const validOptions = yearOptionsData.data.filter(y => !!y.year);
    if(!year.value && validOptions.length) {
      year.update(validOptions[0].year);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year.value, yearOptionsData.data])

  const data = useSmartList(AdminEventApiPath, {
    sorting: {
      disallowedFields: ["description"],
    },
    extraParams: {
      year: year.value,
      // assigned: assignedFilter.value === "me" ? "me" : undefined,
    },
    viewDefault: "all",
    lsKeysPrefix: "__riac_events_adm",
    newRecordDefault: { title: "" },
    schema,
    textFilterFn: EventTextFilter,
    noLoad: !year.value,
  });

  return {
    ...data,
    extraFilters: {
      year,
      yearSelectorSchema,
    },

    // assignedFilter,
  }
  
}


export const useEventsCoorgList = () => {
  const schema = useCalendarEventCoorgSchema();

  // const assignedFilter = useBrowserStoredValue("me", undefined, "__mp_documents_my_all");

  const data = useSmartList(CoorgEventApiPath, {
    sorting: {
      disallowedFields: ["description"],
    },
    extraParams: {
      // assigned: assignedFilter.value === "me" ? "me" : undefined,
    },
    // viewDefault: "all",
    noView: true,
    lsKeysPrefix: "__riac_events_coorg",
    newRecordDefault: { title: "" },
    schema,
    textFilterFn: EventTextFilter,
  });

  return {
    ...data,
    // assignedFilter,
  }
  
}

export type EventsListData = ReturnType<typeof useEventsAdminList>;
